import { render } from "./GpsCamera.vue?vue&type=template&id=577fd126"
import script from "./GpsCamera.vue?vue&type=script&lang=js"
export * from "./GpsCamera.vue?vue&type=script&lang=js"
script.render = render

export default script